// extracted by mini-css-extract-plugin
export default {"root":"VideoLocalPlayer_root__daE-U","video":"VideoLocalPlayer_video__gCFLw"};